import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import LinkBtn from '../../../../../CompUtils/LinkBtn';
import { ActaWithFirma, getActaFile } from '../../../../../../appStore/actas';
import { Button } from 'react-bootstrap';

const CenterTD = styled.td`
  text-align: center;
`;

type Props = { onFirmar: () => void } & ActaWithFirma;
export const ActaFila = (props: Props) => {
  const { titulo, fechaCreacion, idActaConcurso, onFirmar, firmoUsuario } = props;
  const dispatch = useDispatch();
  return (
    <tr>
      <td>{titulo}</td>
      <td>{new Date(fechaCreacion).toLocaleString()}</td>
      <td>
        <LinkBtn transparent onClick={() => dispatch(getActaFile({ idActaConcurso }))}>
          <i className="fa fa-lg fa-file-text-o text-muted" />
        </LinkBtn>
      </td>
      <CenterTD>
        <Button disabled={firmoUsuario} variant="danger" onClick={onFirmar}>
          Firmar
        </Button>
      </CenterTD>
    </tr>
  );
};
